import { useState, useEffect } from 'react';
// The 'switchedOff' event is emitted when there is not enough bandwidth to support
// a track. See: https://www.twilio.com/docs/video/tutorials/using-bandwidth-profile-api#understanding-track-switch-offs
export const useIsTrackSwitchedOff = (track) => {
    const [isSwitchedOff, setIsSwitchedOff] = useState(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    track === null || track === void 0 ? void 0 : track.isSwitchedOff);
    useEffect(() => {
        // Reset the value if the 'track' variable changes
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        setIsSwitchedOff(track === null || track === void 0 ? void 0 : track.isSwitchedOff);
        if (!track)
            return;
        const handleSwitchedOff = () => {
            setIsSwitchedOff(true);
        };
        const handleSwitchedOn = () => {
            setIsSwitchedOff(false);
        };
        track.on('switchedOff', handleSwitchedOff);
        track.on('switchedOn', handleSwitchedOn);
        return () => {
            track.off('switchedOff', handleSwitchedOff);
            track.off('switchedOn', handleSwitchedOn);
        };
    }, [track]);
    return isSwitchedOff;
};
//# sourceMappingURL=useIsTrackSwitchedOff.js.map